module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-1.svg?c08945afd51bb0123a38fee646d00fe4";